import React from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { mergeDeep } from '../../../../helpers/utils';

import Box from '../../../elements/Box';
import FareItemTags from '../../../items/_commons/atoms/FareItemTags';

const modifiers = (fareItem, isLowest, dataType) => {
  const { lowestHistogramBar, noPriceAvailableHistogramBar, histogramBar } = fareItem;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { className, ...obj } = histogramBar;
  const modifiersObj = {};

  // noPriceAvailable
  if (dataType === 'EMPTY_FROM_API') {
    Object.assign(modifiersObj, noPriceAvailableHistogramBar);
  }
  // isLowest
  if (isLowest) {
    Object.assign(modifiersObj, lowestHistogramBar);
  }
  const target = mergeDeep({}, obj);
  const result = mergeDeep(target, modifiersObj);

  return result;
};

const MonthlyHistogramBarV2 = ({
  fareItem,
  fareItem: { barHeightAutoWhenNoData, heightBar, showFareItemTags = true, fareItemTags },
  data,
  tabIndex,
  tabIndexCallToAction,
  focusReferences,
  ...props
}) => {
  const {
    fare,
    fare: { dataType, allFaresEmpty },
    isLowest,
    allPricesEqual,
    FareComponentInstance,
    fareItemHeight,
    fareItemMaxHeight,
    showHistogramBar
  } = data;
  const [className] = useStyles(props);
  const monthHistogramBar = modifiers(fareItem, isLowest, dataType);

  const effectiveFareItemHeight =
    typeof fareItemHeight === 'number' && fareItemHeight > 0 ? fareItemHeight : 0;
  const shouldRenderHistogramBar = showHistogramBar !== false && effectiveFareItemHeight > 0;
  const barHeight =
    allFaresEmpty && barHeightAutoWhenNoData ? `${heightBar}px` : `${fareItemMaxHeight}px`;
  const containerHeight = barHeight;
  const containerPaddingTop = `${Math.max(
    fareItemMaxHeight - effectiveFareItemHeight,
    0
  )}px !important`;
  return (
    <Box
      className={`fr-monthly-carousel fr-monthly-histogram-bar-v2 ${className}`}
      width="100"
      position="relative"
    >
      <Box
        width="100"
        display="flex"
        flexDirection="column"
        className="fr-monthly-histogram-bar-v2"
        style={{
          paddingTop: containerPaddingTop,
          height: containerHeight,
          justifyContent: 'flex-end'
        }}
      >
        {showFareItemTags && shouldRenderHistogramBar && isLowest && !allPricesEqual && (
          <Box position="relative" display="flex" justifyContent="center" marginWidth="1">
            <FareItemTags
              {...(fareItemTags || MonthlyHistogramBarV2.defaultProps.fareItem.fareItemTags)}
              tags={['lowest']}
              id={`fare-item-tags-${fare?.index || 'monthly-bar'}`}
            />
          </Box>
        )}
        {shouldRenderHistogramBar && (
          <Box
            marginTop={isLowest && !allPricesEqual ? '0' : 'auto'}
            margin="1"
            style={{ height: `${effectiveFareItemHeight}px` }}
            {...monthHistogramBar}
          />
        )}
        <FareComponentInstance
          {...fareItem}
          data={fare}
          isLowest={isLowest}
          showDay={false}
          tabIndex={tabIndex}
          focusReferences={focusReferences}
          tabIndexCallToAction={tabIndexCallToAction}
        />
      </Box>
    </Box>
  );
};

MonthlyHistogramBarV2.propTypes = {
  fareItem: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  tabIndex: PropTypes.bool,
  tabIndexCallToAction: PropTypes.bool,
  focusReferences: PropTypes.func
};

MonthlyHistogramBarV2.defaultProps = {
  fareItem: {
    fareItemTags: {
      width: '100',
      tagItem: {
        textColor: 'colorPrimary',
        'cmp-styles': {
          '@theme': 'eds.typo.fontSize5',
          border: '1px solid @palette:colorPrimary',
          'border-radius': '5px',
          padding: '.25rem .5rem',
          span: {
            width: '100%',
            'text-align': 'center'
          }
        }
      }
    }
  },
  data: {},
  tabIndex: false,
  tabIndexCallToAction: true,
  focusReferences: () => {}
};

export default MonthlyHistogramBarV2;
